import PropTypes from 'prop-types';



// ------ shapes

export const SHAPE_COLUMN = {
    cell: PropTypes.func.isRequired,
    header: PropTypes.any,
    id: PropTypes.string.isRequired,
    sortBy: PropTypes.string,
    width: PropTypes.number.isRequired
};


export const SHAPE_SORT = {
    dir: PropTypes.string,
    property: PropTypes.string
};


export const SHAPE_TABLE = {
    columns: PropTypes.arrayOf(
        PropTypes.shape(SHAPE_COLUMN)
    ).isRequired,
    data: PropTypes.array.isRequired,
    onSort: PropTypes.func,
    sortDefault: PropTypes.arrayOf(
        PropTypes.shape(SHAPE_SORT)
    )
};
